import {Injectable} from '@angular/core';

@Injectable()
export class LocalStorageService {

    public set(id: string, data: any) {
        window.localStorage.setItem(id, JSON.stringify(data));
    }

    public get(id: string) {
        if (this.has(id)) {
            return JSON.parse(window.localStorage.getItem(id));
        }

        return null;
    }

    public has(id: string) {
        return null !== window.localStorage.getItem(id);
    }

    public unset(id: string) {
        window.localStorage.removeItem(id);
    }
}



// WEBPACK FOOTER //
// /app/src/services/local-storage.service.ts